import { InterestLevelInterestUnit, OfferingType } from '../../../../../../../../graphql';
import type { InterestLevel } from '../../../indication-form/types';

export const isMarketIndicationsForbidden = (
  isLimitIndicationsOnlyEnabled: boolean,
  interestLevels: readonly InterestLevel[]
) => {
  return (
    isLimitIndicationsOnlyEnabled &&
    interestLevels.some(interestLevel => interestLevel.limitPrice === null)
  );
};
export const isPercentageOfParNoLongerAccepted = (
  isIndicationPriceAsPercentageParEnabled: boolean,
  offeringType: OfferingType | null,
  interestLevels: readonly InterestLevel[]
) => {
  return (
    offeringType === OfferingType.Convertible &&
    !isIndicationPriceAsPercentageParEnabled &&
    interestLevels.some(interestLevel => interestLevel.percentageOfPar !== null)
  );
};
export const isNonSharesUnitIndicationsForbidden = (
  isOnlySharesUnitOnIndicationsEnabled: boolean,
  interestLevels: readonly InterestLevel[]
) => {
  return (
    isOnlySharesUnitOnIndicationsEnabled &&
    interestLevels.some(
      interestLevel => interestLevel.interestUnit !== InterestLevelInterestUnit.Shares
    )
  );
};
